// third party
import * as yup from 'yup';

// project imports
import { getRegexrForAcronym } from 'utils/regexr';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        acronym: yup
            .string()
            .matches(getRegexrForAcronym(), { message: intl.formatMessage({ id: 'ui-comp-formvalidation-acronym-invalid' }) })
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-acronym-required' }))
            .uppercase(),
        icon: yup.string().nullable(),
        color: yup.object().shape({}).nullable()
    });

export default validationSchema;
